import { Component, OnInit, Input } from '@angular/core';
import { Label } from 'ng2-charts';
import { ChartOptions, ChartType } from 'chart.js';
import { COLOR } from 'src/app/services/static/color';
import {TocsCountChart} from '../../../model/model';

@Component({
    selector: 'app-tocs-count-chart',
    templateUrl: './tocs-count-chart.component.html',
    styleUrls: ['./tocs-count-chart.component.scss']
})
export class TocsCountChartComponent implements OnInit {

    @Input() data: TocsCountChart[] = []

    pieChartLabels: Label[] = [];
    pieChartData: number[] = [];

    pieChartType: ChartType = 'bar';
    pieChartLegend = true;

    pieChartOptions: ChartOptions = {
        responsive: true,
        legend: {
            position: 'right',
        },
        plugins: {
            datalabels: {
                formatter: (value, ctx) => {
                    const label = ctx.chart.data.labels[ctx.dataIndex];
                    return label;
                },
            },
        },
        title: {
            display: true,
            position: 'left',
            text: 'Tocs count'
        }
    };

    // pieChartPlugins = [pluginDataLabels];
    pieChartColors = [
        {
            backgroundColor: [
                COLOR.GREEN,
                COLOR.RED,
                COLOR.WARNING
            ],
        },
    ];


    constructor() { }

    ngOnInit() {
        this.data.forEach((entry: TocsCountChart) => {
            if (parseInt(entry.nb_tocs) != -1) {
                this.pieChartData.push(parseInt(entry.count))
                this.pieChartLabels.push(entry.nb_tocs + " toc founded")
            }
        })
    }

}
